export const en = {
    RUB: 'Russian Rubles',
    currency: 'Currency',
    default: 'none',
    from: 'from',
    prefix: 'Prefix',
    price: 'Price',
    priceOld: 'Old price',
    to: 'under'
};
